export default {
    component: {
        width: '80%',
        display: 'inline-block',
        verticalAlign: 'top',
        padding: '20px',
        '@media (max-width: 640px)': {
            width: '100%',
            display: 'block'
        }
    },
    searchBox: {
        padding: '10px 10px 0 20px'
    },
    styleroot: {
        display: 'inline-block',
        verticalAlign: 'top'
    }
};


// WEBPACK FOOTER //
// ./src/css/treeview_styles.js